import axios from '@fs/zion-axios'
import { getAnonSession } from '@fs/zion-session'

import { getQueryString } from './query-utils'

export const getQuickSearch = async ({
  type,
  query = {},
  pagination = { page: 1, results: 12 },
  saveSearch = false,
}) => {
  const URL = '/service/search/discovery/orchestration/one-search'
  const { page, results } = pagination
  const from = (page - 1) * results
  const size = results
  const params = { from, size, searchType: type, ...query, saveSearch }

  if (['tree', 'records'].includes(type)) {
    params['c.race'] = 'on'
    params.includeFacets = true
  }

  if (['records'].includes(type)) {
    params['m.queryRequireDefault'] = 'on'
  }

  // Remove params with an empty string
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, val]) => !(typeof val === 'string' && val.trim().length === 0))
  )

  const stringifiedParams = getQueryString(filteredParams)
  const sessionInfo = await getAnonSession()
  const sessionId = sessionInfo?.session?.id || sessionInfo?.id
  const headers = { 'X-FS-Feature-Tag': 'pah.enabled' }
  headers.Authorization = `Bearer ${sessionId}`
  return axios.get(`${URL}?${stringifiedParams}`, {
    headers,
  })
}
